import SectionLabel from "./SectionLabel";

export default function Firm() {
  return (
    <section
      id="firm"
      className="av-section av-firm"
      aria-labelledby="av-firm-title"
      data-testid="firm-section"
    >
      <div className="av-shell av-split">
        <div>
          <SectionLabel>The firm</SectionLabel>
          <h2 id="av-firm-title">Strategy and implementation from one team.</h2>
        </div>
        <div className="av-reading-copy">
          <p>
            Averentia is a technology transformation firm for organisations
            seeking practical results from technology and AI.
          </p>
          <p>
            Our team combines advisory work with hands-on engineering and
            implementation support for leadership and delivery teams.
          </p>
          <a className="av-text-link" href="/how-we-work">
            How we work <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
}
